import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaCookie } from 'react-icons/fa';
import { useCookieConsent } from '../hooks/useCookieConsent';

const CookieBanner = () => {
  const {
    showBanner,
    acceptAll,
    rejectAll,
  } = useCookieConsent();

  const bannerVariants = {
    hidden: { 
      y: 100, 
      opacity: 0,
      scale: 0.95
    },
    visible: { 
      y: 0, 
      opacity: 1,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 30
      }
    },
    exit: { 
      y: 100, 
      opacity: 0,
      scale: 0.95,
      transition: {
        duration: 0.3
      }
    }
  };


  return (
    <>
      {/* Cookie Banner */}
      <AnimatePresence>
        {showBanner && (
          <motion.div
            variants={bannerVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 z-50"
          >
            <div className="bg-white/95 backdrop-blur-lg border border-gray-200/50 rounded-2xl p-6 shadow-2xl max-w-4xl mx-auto">
              <div className="flex items-start gap-4">
                <motion.div
                  className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-romantic-pink to-romantic-purple rounded-full flex items-center justify-center"
                  animate={{ rotate: [0, 10, -10, 0] }}
                  transition={{ duration: 2, repeat: Infinity, repeatDelay: 3 }}
                >
                  <FaCookie className="text-white text-xl" />
                </motion.div>
                
                <div className="flex-1 min-w-0">
                  <h3 className="text-gray-900 font-bold text-lg mb-2">
                    Yes, we use cookies — not the chocolate-chip kind, but the kind that help you find better matches.
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">
                   Tap Accept All to let us personalize your vibe, boost app performance, and keep things running smoother than your last situationship.
                  </p>
                  
                </div>
              </div>
                  <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <motion.button
                      onClick={acceptAll}
                      className="md:px-8 md:py-3 px-4 py-2 bg-gradient-to-r from-romantic-pink to-romantic-purple text-white font-semibold rounded-lg hover:shadow-lg transition-all duration-200"
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      Accept All Matches
                    </motion.button>
                    
                    <motion.button
                      onClick={rejectAll}
                      className="md:px-8 md:py-3 px-4 py-2 bg-gray-100 text-gray-700 font-semibold rounded-lg hover:bg-gray-200 border border-gray-300 transition-all duration-200"
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                     Only Essentials
                    </motion.button>
                    <motion.button
                      onClick={rejectAll}
                      className="md:px-8 md:py-3 px-4 py-2 bg-gray-100 text-gray-700 font-semibold rounded-lg hover:bg-gray-200 border border-gray-300 transition-all duration-200"
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                     Pick What I Share
                    </motion.button>
                  </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

    </>
  );
};

export default CookieBanner;
